import React, { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { MainRoutes } from "./routes";
import classes from "./Page.module.scss";
import useTheme from "../utils/useTheme";

const Pages = () => {
  const { userData = {} } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  // BrowserRouter keeps the previous page's scroll position, so a new page
  // opened from further down the old one started scrolled past its top.
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Check permission based on action (create, update) and resource (donation, expense)
  const checkPermission = (action, key) => {
    if (!userData?.permissions) {
      return false;
    }
    return userData.permissions[key]?.[action] || false;
  };

  // Validate routes based on permissions
  const validateRoutes = (path) => {
    switch (path) {
      case "/donations/addDonation":
        return checkPermission("create", "donation");
      case "/donations/editDonation":
        return checkPermission("update", "donation");
      case "/expenses/addExpense":
        return checkPermission("create", "expense");
      case "/expenses/editExpense":
        return checkPermission("update", "expense");
      case "/login":
        return !userData?.isLoggedIn;
      default:
        return true; // Return true for other routes or handle as needed
    }
  };

  // Handle route validation when the path changes
  useEffect(() => {
    const isValid = validateRoutes(location.pathname);
    if (!isValid) {
      navigate("/"); // Redirect if the user doesn't have permission
    }
  }, [location, userData, navigate]);

  return <div className={classes.page}>{useRoutes(MainRoutes())}</div>;
};

export default Pages;
